<template>
  <div>
    <div
      id="wrapper"
      style="
        -ms-user-select: none;
        -moz-user-select: -moz-none;
        -khtml-user-select: none;
        -webkit-user-select: none;
        user-select: none;
      "
    >
      <div id="inziCamera"></div>
      <button
        @click="takePhoto"
        :disabled="
          disabledBtn || step2data.mobileNo == '' || data.ocrResult == 'Success'
        "
        class="next-button"
      >
        <!-- // dev 배포 시 주석 풀기 -->
        {{ "신분증 확인하기" }}
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import GlobalEvent from "@/common/Event";
import moment from "moment";

export default {
  props: {
    data: {
      type: Object,
      ocrResult: String,
    },
    step2data: {
      mobileNo: String,
      cropImage: String,
    },
  },
  mounted() {
    $(document).ready(function () {
      inzicamera.initModule($("#inziCamera"));
    });
  },
  computed: {
    disabledBtn() {
      if (
        !navigator.mediaDevices ||
        !navigator.mediaDevices.enumerateDevices ||
        !navigator.mediaDevices.getUserMedia
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    successCallback(image_data) {
      // console.log("image_dataaaaaa", image_data);
      if (image_data.guide_rect) {
        alert("촬영이 완료되었습니다.");
        this.disabledBtn = true;

        this.requestOcr(image_data);
      }
    },
    failedCallback(error) {
      // this.requestOcr(error);
      // alert("촬영이 완료되었습니다. 에러");
    },
    takePhoto() {
      inzicamera.startTakingPhoto(this.successCallback, this.failedCallback);
    },
    async requestOcr(image_data) {
      // console.log("image_data", image_data);

      var formData = new FormData();
      formData.append("taskId", "Main");
      formData.append("formInfo", "IDCARD");
      formData.append("srcFile", image_data.blob);
      formData.append("maskingImage", true);
      formData.append("cropImage", true);

      try {
        const url = this.$isDevServer
          ? "https://ocr.dev.flybit.com/api/ocr"
          : "https://ocr.flybit.com/api/ocr";

        const res = await axios.post(url, formData, {
          headers: {
            "Content-Type": "Multipart/form-data",
          },
        });

        window.onload = function () {
          GlobalEvent.$on("loading", (isLoading) => {
            // console.log("GlobalEvent on loading");
            this.isLoading = isLoading;
          });
        };

        const ocrRes = res.data;
        // console.log("ocrRes", ocrRes);
        this.data.ocrResult = res.data.message;

        if (res.data.resultCode == "200") {
          this.$vs.notify({
            title: "안내",
            text: `신분증 확인을 위해 다음을 눌러주세요.`,
            position: "top-right",
            color: "success",
          });
          this.disabledBtn = true;
        }
        this.data.maskingImage = ocrRes.maskingImage; // 마스킹이미지 base64 encoded
        this.data.cropImage = ocrRes.cropImage; // 원본이미지 base64 encoded
        this.data.formCode = ocrRes.formResult.formCode; // 주민등록증 or 운전면허증 여부(코드)
        this.data.formName = ocrRes.formResult.formName; // 주민등록증 or 운전면허증 여부(이름)
        this.data.inIdCerDate = moment().format("YYYY-MM-DD hh:mm:ss"); // 신분증 인증 일시

        // fieldId / 주민번호 : 101 / 이름 : 102 / 주민등록증 발급일자 : 103 / 운전면허번호 : 104 / 운전면허 시리얼 : 111
        const identity = ocrRes.formResult.fieldResults;
        this.data.fullIdNum = identity.find(
          (ele) => ele.fieldId === "101"
        ).value; // 주민등록번호
        this.data.getOcrName = identity.find(
          (ele) => ele.fieldId === "102"
        ).value; // 이름

        // 주민등록증 인증
        if (this.data.formCode === "S01000001") {
          this.data.issueDate = identity.find(
            (ele) => ele.fieldId === "103"
          ).value; // 주민등록증 발급일자
        }

        // 운전면허증 인증
        if (this.data.formCode === "S01000002") {
          this.data.driverLicenseNo = identity.find(
            (ele) => ele.fieldId === "104"
          ).value; //운전면허번호
          this.data.serialNo = identity.find(
            (ele) => ele.fieldId === "111"
          ).value; // 운전면허 시리얼
        }
      } catch (error) {
        // console.log("error", error);
        this.$vs.notify({
          title: "오류",
          text: `신분증을 인식하지 못했습니다. 다시 시도해 주세요.`,
          position: "top-right",
          color: "danger",
        });
        this.disabledBtn = false;

        // return;
      }
      // return;
    },
  },
};
</script>

<style lang="css" scoped>
.next-button {
  width: 100%;
  padding: 10px 0;
  /* font-size: 12px; */
  border-radius: 2px;
  border: 1px solid #00b473;
  background-color: #00b473;
}
</style>
